import { takeLatest } from "redux-saga/effects";
import * as WORKERS from "../workers/pushs";
import { PUSHS_GET_REQUEST_ACTION } from "../../actions/pushs";

export function* watchSaga() {
  yield takeLatest(PUSHS_GET_REQUEST_ACTION, WORKERS.getPushsData);
}
